
<template>
  <div>
  <div class="text-center">
    <LazyYoutube
      ref="youtubeLazyVideo"
      src="https://www.youtube.com/embed/uEhRIUjidGQ"
      max-width="720px"
      aspect-ratio="16:9"
      thumbnail-quality="standard"
    />
  </div>

    <h5 class="mt-5">Остались еще  вопросы ? </h5>
              <p>Пишите в техподдержку телеграм: <a target="_blank" href="https://telegram.im/@viktor1816">  @viktor1816</a> В сообщении пожалуйста укажите Ваш id {{ user.id }}</p>
    </div>
</template>



<script>
export default {
  data() {
      return {
          user: {}
      };
  },
  created() {
      this.user = JSON.parse(localStorage.user)
  },

};
</script>
